import { formatExperienceSearchSort } from './formatExperienceSearchSort'
import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { formatExperienceSearchDisplayText, type ExperienceSearchDateRange } from './formatExperienceSearchDisplayText'

export function buildExperienceSearchSubmittedActivityEntry(
  searchQuery: string,
  dateRange: ExperienceSearchDateRange,
  sort: Experiences.SortTypes = 'type',
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'experience_search_submitted',
    label: 'Searched experiences',
    displayText: boundActivityDisplayText(formatExperienceSearchDisplayText(searchQuery, dateRange, sort)),
    fields: [{ key: 'sort', value: formatExperienceSearchSort(sort), dataClassification: 'personalised_surface' }],
    sourcePath: 'trip_planner.search.experience',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
